import React from "react";

const Input = ({ label, type, placeholder, onChange, onKeyDown, value, custom, disabled, name, register, error }) => {

  const isError = error ? "input-wrapper-error" : "";

  return (
    <div className={`input-wrapper ${custom} ${isError}`}>
      <label className="input-label">{label}</label>
      <input className="input"  type={type} placeholder={placeholder} onChange={onChange} value={value} disabled={disabled} {...register(name)} />
      {error && <div className="mt-5 text-error">{error.message}</div>}
    </div>
  );
}

Input.defaultProps = {
  type: "text"
};

export default Input;